import Section from './hoc/Section'
import { Link } from 'react-router-dom';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { IoShareSocialSharp } from "react-icons/io5";
import React, {useState} from 'react';
import Image from '../assets/rahul.jpg'; // Adjust the path as necessary
import earn from '../assets/Images/earn.png';
import betaoxtide from '../assets/Images/betaoxtide.png';
import { motion } from "framer-motion";
import barista from '../assets/Images/barista.png';
// import { buildTransform } from 'framer-motion';
const blogData = [
  {
    id: 1,
    title: "EARN PROTOCOL",
    image: earn,
    link: "https://earn.powercity.io/#/"
  },
  {
    id: 2,
    title: "0xTide",
    image: betaoxtide,
    link: "https://beta.0xtide.com"
  },
  {
    id: 3,
    title: "Oxbarista.io",
    image: barista,
    link: "https://0xbarista.io/#/"
  },
];
// Animation Variants
const fadeLeft = {
  hidden: { opacity: 0, x: -120 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 1.2, ease: "easeOut" },
  },
};

const fadeRight = {
  hidden: { opacity: 0, x: 120 },
  show: {
    opacity: 1,
    x: 0,
    transition: { duration: 1.2, ease: "easeOut" },
  },
};

const Project = () => { 
 const settings = { 
    dots: true, 
    infinite: true, 
    speed: 700, 
    slidesToShow: 1, 
    slidesToScroll: 1,
    arrows: true,
    fade: true, // fade effect
    responsive: [
      {
        breakpoint: 768,
        settings: { slidesToShow: 1, slidesToScroll: 1, swipe: true },
      },
    ],
  };
 const [isOpen, setIsOpen] = useState(false);

  return (
   <section className="py-[4rem] text-white text-center">
      <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-center">
        Our Recent <span className="text-purple-500">Projects</span>
      </h2>

       <div className="max-w-[1100px] mx-auto my-0 mt-5 relative">
        <Slider {...settings}>
      {blogData.map((blog, index) => (
        <motion.div
          key={blog.id}
          className="px-4"
          variants={index % 2 === 0 ? fadeLeft : fadeRight} // alternate animations
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.2 }}
        >
          <div className="relative rounded-[30px] overflow-hidden shadow-xl flex flex-col items-center">
            {/* Image wrapped in Link */}
            <Link
              to={blog.link}
              target="_blank"
              rel="noopener noreferrer"
              className="w-full"
            >
              <motion.img
  src={blog.image}
  alt={blog.title}
  className="w-full h-[300px] sm:h-[390px] md:h-[400px] 
             object-contain md:object-cover 
             rounded-[30px] transition-transform duration-500 hover:scale-105"
  whileHover={{ scale: 1.05 }} // subtle zoom effect
/>
            </Link>

            {/* Title always below the image */}
            <motion.p
              className="mt-4 text-white text-3xl md:text-4xl font-semibold text-center"
              variants={fadeRight}
            >
              {blog.title}
            </motion.p>
          </div>
        </motion.div>
      ))}
    </Slider>

        {/* Custom Arrows */}
        <style>{`
          .slick-prev, .slick-next {
            width: 50px;
            height: 50px;
            z-index: 10;
          }
          .slick-prev:before, .slick-next:before {
            font-size: 50px;
            color: white;
          }
          .slick-prev { left: 10px; top: 50%; transform: translate(0, -50%); }
          .slick-next { right: 10px; top: 50%; transform: translate(0, -50%); }
        `}</style>
      </div>
      
      {/* <Link
  to="/grid"
  className="inline-block mt-10 bg-gradient-to-r from-[#722bff] to-[#cc97f4] text-white font-semibold px-6 py-3 rounded-full hover:opacity-90 transition"
>
  Read More
</Link> */}
 
  <div className="relative w-full flex flex-col items-center justify-center mt-32 mb-10 px-4 my-20">
  <h1 className="mb-10 text-3xl sm:text-4xl font-semibold text-center text-white">
    Founder
  </h1>

  <div className="flex flex-col md:flex-row transition-all duration-400 group justify-center items-center w-full max-w-5xl mx-auto">
    {/* Image Side */}
    <div
      className={`cursor-pointer transition-all duration-700 
        group-hover:md:w-[200px] w-full md:w-[400px] h-[470px] 
        rounded-md overflow-hidden shadow-lg border border-black/15 
        bg-purple-950/20 flex justify-center items-center`}
    >
      <img
        src={Image}
        alt="rahul"
        className="w-full h-full object-cover transition-transform duration-0 hover:scale-10"
      />
    </div>

    {/* Right Card Side */}
    <div
  className={`transition-all duration-700 
    h-[470px] w-full p-6 shadow-lg rounded-md justify-between 
    flex flex-col overflow-hidden 
    group-hover:scale-100 
    md:w-0 md:opacity-0 md:ml-0 
    md:group-hover:w-[350px] md:group-hover:opacity-100
  `}
  style={{
    background:
      "linear-gradient(90deg, rgba(209, 207, 207, 1) 0%, rgba(212, 212, 197, 1) 95%)",
  }}
>
      <div>
        <h2 className="text-xl font-bold mb-4 text-black">
          Strategic alignment turns innovation into impact.
        </h2>
        <p className="text-gray-700 text-sm leading-relaxed text-left">
         Strategic alignment turns innovation into impact.
As founder and Head of Technology, I bring together AI, blockchain, and scalable digital solutions to solve real-world business challenges. At the heart of our mission is enabling companies to adapt, grow, and thrive in fast-changing industries. By aligning strategy with execution, we ensure technology isn’t just adopted but truly drives measurable outcomes. Our focus is on building future-proof systems, 
seamless integrations, and innovation-led growth — empowering organizations to stay ahead of the curve.
        </p>
      </div>

      <div className="flex justify-between items-end w-full mt-4">
        <div>
          <h1 className="text-lg sm:text-xl font-semibold text-black text-left">
            Rahul Singh
          </h1>
          <p className="font-medium text-sm sm:text-base text-gray-700">
           Founder & Head of Technology
          </p>
        </div>

        {/* Social Icons */}
       {/* Social / Share Button */}
<div className="relative inline-block">
  {/* Toggleable social icons */}
  <div className={`absolute bottom-full mb-2 right-0 flex flex-col gap-2 z-10 transition-all duration-300 ${isOpen ? "flex" : "hidden"}`}>
    <a href="https://www.youtube.com/@extrnl-p4q" target="_blank" rel="noopener noreferrer" className="border border-black rounded-lg bg-black/40 w-10 h-10 flex items-center justify-center hover:bg-opacity-90 transition">
      <img src="https://img.freepik.com/premium-vector/youtube-icon-illustration-youtube-app-logo-social-media-icon_561158-3674.jpg" alt="YouTube" className="w-5 h-5"/>
    </a>
    <a href="https://x.com/100CryptoTricks" target="_blank" rel="noopener noreferrer" className="border border-black rounded-lg bg-gradient-to-r from-black/40 to-gray-600 w-10 h-10 flex items-center justify-center">
      <img src="https://i.pinimg.com/474x/7d/44/d5/7d44d55ead7dda48bd95632d92fb259d.jpg" alt="Twitter" className="w-5 h-5"/>
    </a>
    <a href="https://www.linkedin.com/in/rahul-singh-ba9143101/" target="_blank" rel="noopener noreferrer" className="border border-black rounded-lg bg-gradient-to-r from-black/40 to-gray-600 w-10 h-10 flex items-center justify-center">
      <img src="https://www.citypng.com/public/uploads/preview/hd-vector-flat-linkedin-in-round-icon-png-701751695046390m4phkuuiqm.png?v=2025062000" alt="LinkedIn" className="w-5 h-5"/>
    </a>
  </div>

  {/* Share Button */}
  <button
    onClick={() => setIsOpen(!isOpen)}
    className={`border border-black rounded-lg bg-gradient-to-r from-black/40 to-gray-600 w-10 h-10 flex items-center justify-center transition-transform duration-500 ${isOpen ? "rotate-45" : "rotate-0"}`}
  >
    <IoShareSocialSharp />
  </button>
</div>
      </div>      
    </div>
  </div>
</div>

        {/* Payment section */}
<motion.section
  className='mt-28 flex flex-col items-center px-4 sm:px-10'
  variants={fadeRight}                  // your right fade variant
  initial="hidden"                      // start hidden
  whileInView="show"                     // animate when in view
  viewport={{ once: true, amount: 0.3 }} // triggers when 30% of section enters viewport
>
  <h2 className='text-4xl sm:text-5xl lg:text-6xl font-bold mb-4 text-center'>
    On-Demand Hiring, Simplified
  </h2>
  <p className='text-base sm:text-lg lg:text-xl text-center text-gray-300 max-w-3xl'>
    Hire a <span className='text-indigo-500'>dedicated development team</span> for as low as $3,000/month — without the overhead of traditional hiring.
  </p>

  {/* Boxes */}
  <div className="mt-8 flex flex-col md:flex-row gap-6 w-full max-w-6xl">
    {/* Box 1 */}
    <div className="flex-1 bg-[#27275578] rounded-lg p-6 sm:p-9 text-left hover:text-white transition">
      <h3 className="text-xl sm:text-2xl font-semibold mb-2 text-indigo-500">Base Team</h3>
      <h4 className="text-lg sm:text-xl font-bold pt-2 sm:pt-3">$3,000 / month</h4>
      <div className='mt-4 sm:mt-6 space-y-1 sm:space-y-2 text-gray-300 font-medium'>
        <p>✅ 1 Backend Developer</p>
        <p>✅ 1 Frontend Developer</p>
        <p>✅ 30 hours per week</p>
      </div>
    </div>

    {/* Box 2 */}
    <div className="flex-1 bg-[#27275578] rounded-lg p-6 sm:p-9 text-left hover:text-white transition">
      <h3 className="text-xl sm:text-2xl font-semibold mb-2 text-indigo-500">Designer Add-On</h3>
      <h4 className="text-lg sm:text-xl font-bold pt-2 sm:pt-3">+$500</h4>
      <div className='mt-4 sm:mt-6 space-y-1 sm:space-y-2 text-gray-300 font-medium'>
        <p>🎨 Up to 15 Pages</p>
        <p>📞 4 Consultation Calls</p>
        <p>🔄 3 Iterations</p>
      </div>
    </div>

    {/* Box 3 */}
    <div className="flex-1 bg-[#27275578] rounded-lg p-6 sm:p-9 text-left hover:text-white transition">
  <h3 className="text-xl sm:text-2xl font-semibold mb-4 text-indigo-500">
    QA & Project Manager
  </h3>
  {/* Single line flex container */}
  <div className="flex flex-wrap items-center gap-3 text-sm sm:text-base text-gray-300">
    <span className="flex items-center gap-1">🧪 Quality Assurance (QA) to ensure bug-free delivery</span>
    <span className="flex items-center gap-1">📋 Project Manager (PM) to keep everything on track</span>
    <span className="text-xs sm:text-sm text-gray-400">*Pricing for QA and PM may vary depending on project scope.</span>
  </div>
</div>

  </div>
</motion.section>

    </section>
  );
};

export default Section(Project,"project");
